<template>
  <OPaginatedTable
    class="fixed-table dense-table"
    dense
    :spec="spec"
    :items="rows"
  />
  <!--
      :count="count"
        :navigation="nav"
      @rowClicked="showTrip"
      @update:navigation="v => (nav = v)"
      -->
</template>

<script>
import { brDateTime, brNum, sDuration } from 'oderon-commons/src/formatters'
import OPaginatedTable from 'oderon-vue/cpts/OPaginatedTable'

const _check = 'mdi-checkbox-marked-circle',
  _cross = 'mdi-close-circle',
  _green = 'green--text icon-small',
  _red = 'red--text icon-small',
  _valid = { iconText: _check, iconClass: _green },
  _invalid = { iconText: _cross, iconClass: _red }

export default {
  components: { OPaginatedTable },
  props: {
    rows: { type: Array }
  },
  data() {
    return {
      spec: {
        columns: [
          { t: 'ID|', d: 'id', w: 90 },
          { t: '||', d: 'isValid', w: 40, f: (v) => (v ? _valid : _invalid) },
          { t: 'Início|', d: 'startTimestamp', w: 130, f: brDateTime },
          { t: 'Motorista', d: 'driver.name', w: 150 },
          { t: 'Duração|', d: 'durationS', w: 100, f: sDuration },
          { t: 'Dist.(m)|', d: 'distanceM', w: 100, f: brNum }
        ],
        rowClass: (r) => {
          return r.isOngoing ? 'blue lighten-4' : ''
        },
        defaultSortable: false
      }
    }
  }
}
</script>

<style></style>
